<div class="bciti-color-select-container" [ngStyle]="{ 'width': width }">
  <label class="bciti-color-select-label">{{ 'common.color' | translate }}</label>
  <div class="bciti-select"
    [class.valid]="valid"
    [class.invliad]="invalid"
    [class.touched]="touched"
    [class.validation]="validation"
    (click)="showDropdown()" 
    #drop
    >
    <div class="bciti-color-select-option grid-selected">
      <div class="color-option" [ngStyle]="{ 'background-color': value }"></div>
      <span class="icon-caret-down"></span>
    </div>
    <app-bciti-select-grid-dropdown [scrollable]="false" [reference]="drop">
      <div class="bciti-color-select-option grid-option" *ngFor="let color of colors" (click)="select(color)">
        <div class="color-option" [ngStyle]="{ 'background-color': color }"></div>
      </div>
    </app-bciti-select-grid-dropdown>
  </div>
</div>